/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as EmailValidator from 'email-validator';
import { ERR_CLIENT_CONTACT_REQUIRED, ERR_CLIENT_NAME_REQUIRED, ERR_EMAIL, ERR_EMAIL_INVALID, LABEL_BTN_CANCEL, LABEL_BTN_SAVE, UNKNOWN_ERR } from 'src/constants/constant';
import { TextField, Typography, Divider, Autocomplete } from '@mui/material';
import type { ClientFormInputs, RootState } from '../types/types';
import { useSelector } from 'react-redux';
import { addClientData } from 'src/services/clientService';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import OutlineButton from '../MUICustomButton/OutlineButton';
import GradientButton from '../MUICustomButton/GradientButton';
import { useNavigate } from 'react-router-dom';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import moment from 'moment';
import { getESPConnectionData } from '../../services/emailAPIESPServices';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { ArrowDown01Icon } from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { Calendar03Icon } from '@hugeicons-pro/core-stroke-rounded';

const validationSchema = Yup.object().shape({
    clientName: Yup.string().required(ERR_CLIENT_NAME_REQUIRED).matches(/^[A-Za-z0-9][A-Za-z0-9 ]*$/, "First character should not be a space and no special characters allowed"),
    clientContact: Yup.string().required(ERR_CLIENT_CONTACT_REQUIRED).matches(/^[A-Za-z0-9][A-Za-z0-9 ]*$/, "First character should not be a space and no special characters allowed"),
    // lastName: Yup.string().required(UPDATE_USER_ERROR_LAST_NAME).matches(/^[a-zA-Z0-9\s]*$/, NEW_USER_ERROR_INVALID_LAST_NAME),
    email: Yup.string()
        .required(ERR_EMAIL)
        .email(ERR_EMAIL_INVALID)
        .test(
            'is-valid-email',
            ERR_EMAIL_INVALID,
            (value) => value === '' || EmailValidator.validate(value),
        ),
    subscriptionStartDate: Yup.string().required("Please enter subscription start date")
        .test("valid-date", "Invalid date format", (value) =>
            moment(value, "YYYY-MM-DD", true).isValid()
        ),
    subscriptionEndDate: Yup.string().required("Please enter subscription end date").test("valid-date", "Invalid date format", (value) =>
        moment(value, "YYYY-MM-DD", true).isValid()
    )
        .test("endAfterStart", "Subscription end date must be after subscription start date", function (value) {
            const { subscriptionStartDate } = this.parent;
            return moment(value, "YYYY-MM-DD").isSameOrAfter(moment(subscriptionStartDate, "YYYY-MM-DD"));
        }),
    hldAccountManagerName: Yup.string().required("Please enter HLD account manager name").matches(/^[A-Za-z0-9][A-Za-z0-9 ]*$/, "First character should not be a space and no special characters allowed"),
    hldAccountManagerEmail: Yup.string()
        .required("Please enter HLD account manager email")
        .email(ERR_EMAIL_INVALID)
        .test(
            'is-valid-email',
            ERR_EMAIL_INVALID,
            (value) => value === '' || EmailValidator.validate(value),
        ),
    subscriptionCampaignCount: Yup.number()
        .moreThan(1, "Number must be greater than 1")
        .lessThan(2147483647, "Number must be less than 2147483647")
        .test("is-integer", "Only whole numbers are allowed", (value) => Number.isInteger(value))
        .required("Please enter number of campaigns").typeError("Please enter valid number"),
    subscriptionEmailCount: Yup.number()
        .moreThan(1, "Number must be greater than 1")
        .lessThan(2147483647, "Number must be less than 2147483647")
        .test("is-integer", "Only whole numbers are allowed", (value) => Number.isInteger(value))
        .required("Please enter number of emails").typeError("Please enter valid number"),
    espConnectionId: Yup.string().required("Please select email service provider"),
    campaignDailyLimit: Yup.number()
                                    .typeError("Only numbers are allowed")
                                    .min(0, "Number must be 0 or greater")
                                    .max(2147483647, "Number must be less than or equal to 2147483647")
                                    .test("is-integer", "Only whole numbers are allowed", (value) =>
                                    value === undefined || Number.isInteger(value)),
    campaignHourlyLimit: Yup.number()
                                    .typeError("Only numbers are allowed")
                                    .min(0, "Number must be 0 or greater")
                                    .max(2147483647, "Number must be less than or equal to 2147483647")
                                    .test("is-integer", "Only whole numbers are allowed", (value) =>
                                    value === undefined || Number.isInteger(value)),
    hldClientId: Yup.number()
        .transform((value, originalValue) => {
            // strip spaces and convert empty string to undefined so Yup handles optional/required correctly
            if (typeof originalValue === 'string') {
                const v = originalValue.replace(/\s+/g, '');
                return v === '' ? undefined : Number(v);
            }
            return value;
        })
        .moreThan(0, "Number must be greater than 0")
        .test("is-integer", "Only whole numbers are allowed", (value) => value === undefined || Number.isInteger(value))
        .typeError("Please enter valid number"),
    numberOfDaysToArchiveData: Yup.number()
                                    .typeError("Please enter a valid number")
                                    .min(1, "Please enter a number greater than 0")
                                    .max(2147483647, "Please enter a valid number")
                                    .test("is-integer", "Please enter only whole numbers", (value) =>
                                    value === undefined || Number.isInteger(value)),    
});


export interface PropsType {
    // closeModal: () => void;
    // refreshPage: () => void;
    parentId?: string;
}

function AddClientForm({ parentId }: PropsType): JSX.Element {

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [espConnectionData, setESPConnectionData] = useState<any>([])

    const { user } = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate()
    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue
    } = useForm<ClientFormInputs>({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            clientName: '',
            clientContact: '',
            email: '',
            numberOfDaysToArchiveData: 1,
        },
    });

    useEffect(() => {
        getESPConnectionData().then(
            (res: any) => {
                if(res.status === 200) {
                    if(res.data.result === 1) {
                        setESPConnectionData(res.data.data)
                    }
                }
            }
        )
        .catch(
            (error) => console.log(error)
        )
    }, [])

    const onSubmit = async (data: ClientFormInputs): Promise<void> => {
        console.log("TEST", data);
        setIsLoading(true)
        // data.createdBy = user?.id;
        // data.parentId = parentId !== undefined ? parentId : '0';

        const requestParams = {
            "clientName": data.clientName,
            "email": data.email,
            "clientContact": data.clientContact,
            "parentId": parentId !== undefined ? parentId : '0',
            "createdBy": user?.id,
            "hldAccountManagerName": data.hldAccountManagerName,
            "hldAccountManagerEmail": data.hldAccountManagerEmail,
            "subscriptionStartDate": moment(data.subscriptionStartDate),
            "subscriptionEndDate": moment(data.subscriptionEndDate),
            "subscriptionCampaignCount": data.subscriptionCampaignCount,
            "subscriptionEmailCount": data.subscriptionEmailCount,
            "espConnectionId": data.espConnectionId,
            "espDomainName": data.espDomainName,
            "campaignDailyLimit": data.campaignDailyLimit ?? 0,
            "campaignHourlyLimit": data.campaignHourlyLimit ?? 0,
            "hldClientId": data.hldClientId ?? null,
            "dataArchiveDays": data.numberOfDaysToArchiveData ?? 0,

        }
        // const requestData: any = {
        //     ...data,
        //     createdBy: user?.id, // Add createdBy field
        // };

        try {
            console.log("Request Data:", requestParams);
            const res = await addClientData(requestParams);

            if (res.status === 200) {
                if (res.data.result === 1) {
                    NotificationManager.success(parentId !== undefined ? "Sub-client created successfully" : "Client created successfully");
                    setTimeout(() => {
                        if (parentId === undefined) {
                            handleBackClick()
                        } else {

                            navigate(-1)
                        }

                    }, 1000)
                } else {
                    const errorMsg: any = res.data.messages[0].message
                    if(!errorMsg){                        
                        NotificationManager.error(res.data.messages); 
                    } else if(errorMsg.includes('Client name already exists')){
                        NotificationManager.error('Client name already exists');
                    } 
               
                }
            }
        } catch (error) {
            console.error("Error occurred:", error);
            NotificationManager.error("Unknown error has occurred");
        } finally {
            setIsLoading(false);
        }
        // return true;
    }

    const handleBackClick = (): void => {
        navigate('/admin/manage-clients')
    }

    
    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '10px' }}>
                Profile
            </Typography>
            <Divider sx={{ color: '#D9D9D9', marginBottom: '10px' }} />
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    void handleSubmit(onSubmit)(e);
                }}
            >
                <div className='form-sub-container'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        Client Information
                    </Typography>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="clientName"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label={parentId !== undefined ? "Sub-client Name*" : "Client Name*"}
                                            autoComplete="off"
                                            placeholder={parentId !== undefined ? "Sub-client name*" : "Client name*"}

                                            error={Boolean(errors.clientName)}
                                            // helperText={errors.clientName?.message}
                                        />
                                        {errors.clientName && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.clientName?.message}</div>}
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="clientContact"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label={parentId !== undefined ? "Sub-client contact*" : "Client Contact*"}
                                            autoComplete="off"
                                            placeholder={parentId !== undefined ? "Sub-client contact*" : "Client contact*"}

                                            error={Boolean(errors.clientContact)}
                                            // helperText={errors.clientContact?.message}
                                        />
                                        {errors.clientContact && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.clientContact?.message}</div>}
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="w-full relative ">


                            <div className="mb-[30px]">
                                <Controller
                                    name="email"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label="Email*"
                                            autoComplete="off"
                                            placeholder="Email*"

                                            error={Boolean(errors.email)}
                                            // helperText={errors.email?.message}
                                        />
                                        {errors.email && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.email?.message}</div>}
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="subscriptionStartDate"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        // <TextField
                                        //     {...field}
                                        //     fullWidth
                                        //     label={parentId !== undefined ? "Sub-client contact*" : "Subscription Start Date"}
                                        //     autoComplete="off"
                                        //     placeholder={parentId !== undefined ? "Sub-client contact*" : "Subscription Start Date"}

                                        //     error={Boolean(errors.clientContact)}
                                        //     helperText={errors.clientContact?.message}
                                        // />
                                        <>
                                            <div className="datepicker-container">
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DemoContainer components={['DatePicker']}>
                                                        <DatePicker
                                                            label="Subscription Start Date*"
                                                            onChange={(newValue) => field.onChange(moment(newValue).format("YYYY-MM-DD"))}
                                                            minDate={moment()} // Use moment for minDate
                                                            slotProps={{
                                                                textField: ({ position }) => ({
                                                                    error: errors.subscriptionStartDate && Boolean(errors.subscriptionStartDate)
                                                                }),
                                                            }}
                                                            slots={{
                                                                openPickerIcon: () => (
                                                                    <HugeiconsIcon
                                                                        icon={Calendar03Icon}
                                                                        size={18}
                                                                        color="#3A3A3A"
                                                                        strokeWidth={0.5}
                                                                    />
                                                                )
                                                            }}
                                                        />
                                                    </DemoContainer>
                                                </LocalizationProvider>
                                            </div>
                                            {
                                                errors.subscriptionStartDate && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.subscriptionStartDate?.message}</div>
                                            }
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="w-full relative ">
                            <div className="mb-[30px]">
                                <Controller
                                    name="subscriptionEndDate"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <>
                                            <div className="datepicker-container">
                                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                                    <DemoContainer components={['DatePicker']}>
                                                        <DatePicker
                                                            label="Subscription End Date*"
                                                            onChange={(newValue) => field.onChange(moment(newValue).format("YYYY-MM-DD"))}
                                                            minDate={moment()} // Use moment for minDate
                                                            slotProps={{
                                                                textField: ({ position }) => ({
                                                                    error: errors.subscriptionEndDate && Boolean(errors.subscriptionEndDate)
                                                                }),
                                                            }}
                                                            slots={{
                                                                openPickerIcon: () => (
                                                                    <HugeiconsIcon
                                                                        icon={Calendar03Icon}
                                                                        size={18}
                                                                        color="#3A3A3A"
                                                                        strokeWidth={0.5}
                                                                    />
                                                                )
                                                            }}
                                                        />
                                                    </DemoContainer>
                                                </LocalizationProvider>
                                            </div>
                                            {
                                                errors.subscriptionEndDate && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.subscriptionEndDate?.message}</div>
                                            }
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="hldAccountManagerName"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label={"HLD Account Manager Name*"}
                                            autoComplete="off"
                                            placeholder={"HLD account manager name*"}

                                            error={Boolean(errors.hldAccountManagerName)}
                                            // helperText={errors.hldAccountManagerName?.message}
                                        />
                                        {
                                            errors.hldAccountManagerName && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.hldAccountManagerName?.message}</div>
                                        }
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="w-full relative ">


                            <div className="mb-[30px]">
                                <Controller
                                    name="hldAccountManagerEmail"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label="HLD Account Manager Notifications*"
                                            autoComplete="off"
                                            placeholder="HLD account manager notifications*"

                                            error={Boolean(errors.hldAccountManagerEmail)}
                                            // helperText={errors.hldAccountManagerEmail?.message}
                                        />
                                        {
                                            errors.hldAccountManagerEmail && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.hldAccountManagerEmail?.message}</div>
                                        }
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="hldClientId"
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label={"HLD Client ID"}
                                            autoComplete="off"
                                            placeholder={"HLD client id"}
                                            error={Boolean(errors.hldClientId)}
                                            // helperText={errors.hldClientId?.message}
                                            inputProps={{ inputMode: 'numeric', pattern: '\\d*', min: 1 }}
                                            onChange={(e) => {
                                                // strip spaces before updating form state
                                                const sanitized = e.target.value.replace(/\s+/g, '');
                                                field.onChange(sanitized);
                                            }}
                                            onKeyDown={(e) => {
                                                // prevent space key
                                                if (e.key === ' ') e.preventDefault();
                                            }}
                                        />
                                        {
                                            errors.hldClientId && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.hldClientId?.message}</div>
                                        }
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='form-sub-container'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        Email Configuration
                    </Typography>
                    
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="espConnectionId"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <>
                                        <Autocomplete
                                            options={espConnectionData} // The list of clients
                                            getOptionLabel={(option: any) => option.connectionName} // Use clientName for display
                                            popupIcon={
                                              <HugeiconsIcon
                                                icon={ArrowDown01Icon}
                                                size={18}
                                                color="#3A3A3A"
                                                strokeWidth={0.2}
                                            
                                              />
                                            }
                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                            //@ts-ignore
                                            isOptionEqualToValue={(option, value) => option.id === value} // Match by ID
                                            // value={clients.find((client) => client.id === field.value)} // Match current value
                                            onChange={(_, selectedConnection) => {
                                                // const clientId = selectedClient?.id; // Handle null case
                                                // console.log('Selected client:', clientId);
                                                // handleClientClick(Number(clientId)); // Trigger your client click handler
                                                field.onChange(selectedConnection.id); // Update the form state
                                                setValue("espDomainName", selectedConnection.domain)
                                                setValue("fromEmailName", selectedConnection.fromName)
                                                setValue("fromEmailAddress", selectedConnection.fromEmail)
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Email Service Provider*"
                                                    placeholder="Select email service provider"
                                                    error={Boolean(errors.espConnectionId)}
                                                    // helperText={errors.espConnectionId?.message}
                                                />
                                            )}
                                            disableClearable // Prevent the clear button
                                        />
                                        {
                                            errors.espConnectionId && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.espConnectionId?.message}</div>
                                        }
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="w-full relative ">


                            <div className="mb-[30px]">
                                <Controller
                                    name="espDomainName"
                                    control={control}
                                    defaultValue=''
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label="Domain Name"
                                            autoComplete="off"
                                            placeholder="Domain name"
                                            disabled

                                            error={Boolean(errors.espDomainName)}
                                            helperText={errors.espDomainName?.message}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="fromEmailName"
                                    control={control}
                                    defaultValue=""
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label={"From Email Name"}
                                            autoComplete="off"
                                            placeholder={"From email name"}
                                            disabled

                                            error={Boolean(errors.fromEmailName)}
                                            helperText={errors.fromEmailName?.message}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                        <div className="w-full relative ">


                            <div className="mb-[30px]">
                                <Controller
                                    name="fromEmailAddress"
                                    defaultValue=""
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label="From Email Address"
                                            autoComplete="off"
                                            placeholder="From email address"
                                            disabled

                                            error={Boolean(errors.fromEmailAddress)}
                                            helperText={errors.fromEmailAddress?.message}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='form-sub-container'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        Throughput Information
                    </Typography>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="campaignDailyLimit"
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            // type='number'
                                            fullWidth
                                            label={"Daily Limit"}
                                            autoComplete="off"
                                            placeholder={"Daily limit"}

                                            error={Boolean(errors.campaignDailyLimit)}
                                            // helperText={errors.campaignDailyLimit?.message}
                                        />
                                        {
                                            errors.campaignDailyLimit && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.campaignDailyLimit?.message}</div>
                                        }
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="w-full relative ">


                            <div className="mb-[30px]">
                                <Controller
                                    name="campaignHourlyLimit"
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            // type='number'
                                            label="Hourly Limit"
                                            autoComplete="off"
                                            placeholder="Hourly limit"

                                            error={Boolean(errors.campaignHourlyLimit)}
                                            // helperText={errors.campaignHourlyLimit?.message}
                                        />
                                        {
                                            errors.campaignHourlyLimit && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.campaignHourlyLimit?.message}</div>
                                        }
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='form-sub-container'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        Subscription
                    </Typography>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="subscriptionCampaignCount"
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            // type='number'
                                            fullWidth
                                            label={"# of Campaigns*"}
                                            autoComplete="off"
                                            placeholder={"# of campaigns*"}

                                            error={Boolean(errors.subscriptionCampaignCount)}
                                            // helperText={errors.subscriptionCampaignCount?.message}
                                        />
                                        {
                                            errors.subscriptionCampaignCount && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.subscriptionCampaignCount?.message}</div>
                                        }
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="w-full relative ">


                            <div className="mb-[30px]">
                                <Controller
                                    name="subscriptionEmailCount"
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            // type='number'
                                            label="# of Emails*"
                                            autoComplete="off"
                                            placeholder="# of emails*"

                                            error={Boolean(errors.subscriptionEmailCount)}
                                            // helperText={errors.subscriptionEmailCount?.message}
                                        />
                                        {
                                            errors.subscriptionEmailCount && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.subscriptionEmailCount?.message}</div>
                                        }
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                </div>


                <div className='form-sub-container'>
                    <Typography variant="h6" gutterBottom sx={{ color: '#3A3A3A', fontSize: '16px', fontWeight: '600', marginBottom: '20px' }}>
                        Data Archiving Configuration
                    </Typography>
                    <div className='grid gap-5 grid-cols-2'>
                        <div className='w-full relative'>
                            <div className="mb-[30px]">
                                <Controller
                                    name="numberOfDaysToArchiveData"
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            fullWidth
                                            label={"Data retention period (days)*"}
                                            autoComplete="off"
                                            placeholder={"Data retention period (days)*"}

                                            error={Boolean(errors.numberOfDaysToArchiveData)}
                                            // helperText={errors.numberOfDaysToArchiveData?.message}
                                        />
                                        {
                                            errors.numberOfDaysToArchiveData && <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal"><img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />{errors.numberOfDaysToArchiveData?.message}</div>
                                        }
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                       
                    </div>
                </div>

                <div className='flex gap-2 justify-end mt-[30px]'>
                    <OutlineButton color='gray' onClick={() => handleBackClick()} width='130px'>{LABEL_BTN_CANCEL}</OutlineButton>
                    <GradientButton type='submit' color='red' onClick={handleBackClick} width='130px'>{!isLoading ? LABEL_BTN_SAVE : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                </div>
            </form>
        </React.Fragment>
    )
}

export default AddClientForm